import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, Canceler } from 'axios';
import qs from 'query-string';
import history from 'lib/history';
import accountManage from '@/store/account-manage';
import { langMap, ELanguage } from '@/interfaces/common';

let cancel!: Canceler;
const ROUTE_CHANGE = 'ROUTE_CHANGE';

const requestInterceptor = (config: AxiosRequestConfig) => {
  config.headers = {
    'Accept-Language': langMap[accountManage.language ?? ELanguage.EN],
  };
  return config;
};

const errorInterceptor = (err: AxiosError) => {
  if (err.response?.status === 401) {
    history.push('/login');
  }
  throw new Error(err.response?.data?.message);
};

const responseInterceptor = (res: AxiosResponse) => {
  if (res.data.code !== 'SUCCESS') {
    throw {
      isAxiosError: false,
      request: res.request,
      name: res.data.code,
      config: res.config,
      code: res.data.code,
      message: res.data.message,
      response: res,
    } as AxiosError;
  } else {
    return res;
  }
};

/**
 * Axios instance with error handler
 */
const instance = axios.create({
  baseURL: '/api',
  timeout: 60000,
  paramsSerializer: params => {
    return qs.stringify(params);
  },
});

/**
 * Axios instance ignoring error handler
 */
const instanceIgnore = axios.create({
  baseURL: '/api',
  timeout: 60000,
  paramsSerializer: params => {
    return qs.stringify(params);
  },
});

instance.interceptors.response.use(responseInterceptor, errorInterceptor);
instance.interceptors.request.use(requestInterceptor);
instanceIgnore.interceptors.request.use(requestInterceptor);

const msInstance = axios.create({
  baseURL: '/merchant-service/v1',
  timeout: 60000,
  paramsSerializer: params => {
    return qs.stringify(params);
  },
});
msInstance.interceptors.response.use(responseInterceptor);

export { instance as handle, msInstance as msAjax, instanceIgnore as ignore, ROUTE_CHANGE, cancel };
export default instance;
